// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import keyMirror from 'mattermost-redux/utils/key_mirror';

export default keyMirror({
    RECEIVED_BOT_ACCOUNTS: null,
    RECEIVED_BOT_ACCOUNT: null,
});
